<script lang="ts">
export default { name: 'SchoolItemCheckbox' }
</script>

<script setup lang="ts">
import { Common } from '@/components'
defineProps({ checked: { type: Boolean, default: false } })
</script>

<template>
  <div class="school-item-checkbox">
    <Common.Icon v-if="checked" name="check" class="relative text-orange text-[24px]" />
  </div>
</template>

<style scoped>
.school-item-checkbox {
  /* 縦のサイズ： 50px ( 余白 10px + 枠 26px + 余白 4px + 文字 10px ) */
  @apply relative w-[26px] h-[50px] pt-[10px] pb-[14px] flex place-content-center isolate;
  /* 四角枠 */
  @apply before:absolute before:top-[10px] before:inset-x-0 before:block before:w-[26px] before:h-[26px] before:border-2 before:rounded-md before:bg-white;
  /* Check文字 */
  @apply after:content-['Check'] after:absolute after:inset-x-0 after:bottom-0 after:text-orange after:text-[10px] after:font-bold;
}
</style>
